import "./activityList.scss";
import { Fragment } from "react";
import CouponRedeemed from "./CouponRedeemed";
import MembershipVisit from "./MembershipVisit";
import MembershipExpired from "./MembershipExpired";
import MembershipPurchased from "./MembershipPurchased";
import SbLoading from "../../../../../../../../common/SbLoading";
import Typography from "../../../../../../../../common/Typography";
import Button from "../../../../../../../../common/Buttons/Button";
import SbEmptyState from "../../../../../../../../common/Cards/SbEmptyState";

const ActivityList = ({
  currMemb,
  handleRenew,
  activityData,
  currencyView,
  activityDocsList,
  isLoadingActivity,
  fetchMembershipActivity,
}) => {
  return (
    <div className="membership-activity-list">
      <Typography tag="h3" weight="medium">
        Your Activity
      </Typography>
      {activityData?.totalDocs > 0 ? (
        <>
          {activityDocsList?.map((activity, i) => {
            if (activity?.action === "membership:purchase")
              return (
                <MembershipPurchased
                  key={i}
                  activity={activity}
                  currencyView={currencyView}
                />
              );
            if (activity?.action === "purchase")
              return (
                <MembershipVisit
                  key={i}
                  activity={activity}
                  currencyView={currencyView}
                />
              );
            if (activity?.action === "redemption")
              return (
                <CouponRedeemed
                  key={i}
                  activity={activity}
                  currencyView={currencyView}
                />
              );
            if (activity?.action === "membership:expiry")
              return (
                <MembershipExpired
                  key={i}
                  currMemb={currMemb}
                  activity={activity}
                  handleRenew={handleRenew}
                  currencyView={currencyView}
                />
              );
            return <Fragment key={i} />;
          })}
          {isLoadingActivity ? <SbLoading /> : <></>}
          {activityData?.totalPages > 0 &&
            activityData?.page < activityData?.totalPages && (
              <Button
                isPlain={true}
                text="Show more"
                variant="secondary"
                customClass="show-more-btn"
                handleClick={() => fetchMembershipActivity(true)}
                disabled={!activityData?.hasNextPage || isLoadingActivity}
              />
            )}
        </>
      ) : (
        <SbEmptyState
          imgWidth={24}
          imgHeight={24}
          img="/assets/icons/mobile-phone.svg"
          title="You'll see your membership benefits redemption activity once you start redeeming"
        />
      )}
    </div>
  );
};

export default ActivityList;
